/**
 * settings — part of the German catalogue (the reference language).
 * Merged in `i18n/de.ts`; every key here must exist in `i18n/en/settings.ts`.
 */

export const settings = {

  /* ---------------- Passwort: vergessen, zurücksetzen, ändern ---------------- */
  'pw.forgot.link': 'Passwort vergessen?',
  'pw.forgot.title': 'Passwort zurücksetzen',
  'pw.forgot.lead':
    'Wir schicken einen Link an die E-Mail-Adresse des Kontos. Der Link gilt 60 Minuten und kann einmal benutzt werden.',
  'pw.forgot.send': 'Link schicken',
  'pw.forgot.sent': 'Wenn ein Konto existiert, haben wir einen Link geschickt.',
  'pw.forgot.sent.hint':
    'Die Mail kommt in wenigen Minuten – bitte auch den Spam-Ordner ansehen. Höchstens drei Links pro Stunde und Konto.',
  'pw.reset.title': 'Neues Passwort setzen',
  'pw.reset.lead':
    'Danach sind alle Geräte abgemeldet – auch dieses. Melden Sie sich anschließend mit dem neuen Passwort an.',
  'pw.reset.save': 'Passwort setzen',
  'pw.reset.again': 'Neuen Link anfordern',
  'pw.reset.notoken': 'Dieser Link ist unvollständig – er enthält kein Token. Fordern Sie einen neuen an.',
  'pw.reset.done': 'Passwort geändert. Bitte mit dem neuen Passwort anmelden.',
  'pw.tologin': 'Zur Anmeldung',
  'pw.change': 'Passwort ändern',
  'pw.change.lead':
    'Dieses Gerät bleibt angemeldet, alle anderen werden abgemeldet.',
  'pw.current': 'Aktuelles Passwort',
  'pw.new': 'Neues Passwort',
  'pw.repeat': 'Neues Passwort wiederholen',
  'pw.rule': '(mindestens {n} Zeichen)',
  'pw.save': 'Passwort speichern',
  'pw.cancel': 'Abbrechen',
  'pw.changed': 'Passwort geändert.',
  'pw.err.short': 'Das neue Passwort ist zu kurz – mindestens {n} Zeichen.',
  'pw.err.mismatch': 'Die beiden Passwörter stimmen nicht überein.',
  'pw.err.current': 'Das aktuelle Passwort ist falsch.',
  'pw.err.email': 'Bitte eine gültige E-Mail-Adresse eingeben.',

  /* ---------------- Einstellungen ---------------- */
  'settings.title': 'Einstellungen',
  'settings.appearance': 'Darstellung',
  'settings.language': 'Sprache',
  'settings.theme': 'Design',
  'settings.theme.system': 'System',
  'settings.theme.light': 'Hell',
  'settings.theme.dark': 'Dunkel',
  'settings.account': 'Konto',
  'settings.signedout': 'Anmelden, um Flüge zu sichern.',
} as const;
